import React from 'react';
import './Services.css';

const Services = () => {
    return (
        <div className="services-page">
            <div className="services-hero">
                <h1>Our Services</h1>
                <p>Comprehensive digital architecture designed for institutional growth.</p>
            </div>

            <section className="services-list">
                <div className="service-item">
                    <div className="service-text">
                        <span>01</span>
                        <h3>Digital Strategy</h3>
                        <p>We map out the entire user journey to ensure your website acts as a high-performing asset for your business.</p>
                    </div>
                </div>

                <div className="service-item">
                    <div className="service-text">
                        <span>02</span>
                        <h3>Multi-Page Systems</h3>
                        <p>Unlike basic landing pages, our Pillar builds allow for deep content structures across multiple dedicated pages.</p>
                    </div>
                </div>

                <div className="service-item">
                    <div className="service-text">
                        <span>03</span>
                        <h3>Brand Integrity</h3>
                        <p>Every pixel is aligned with your corporate identity, ensuring a polished look that builds immediate trust.</p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Services;